import { AdminWrapper } from "./styled"
import AdminSideBar from "./components/AdminSideBar"
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AdminHeader from "./components/AdminHeader";
import AdminDashBoard from "./Dashboard"
import Staff from "./Staff"
import Customer from "./Customer";
import TourType from "./TourType";
import NewsCategories from "./NewsCategories";
import News from "./News";
import Tour from "./Tour";
import TourOrder from "./TourOrder";
import Bill from "./Bill";

const Admin = () => {
    const location = useLocation();
    const queryPath = location.pathname;
    const myArray = queryPath.split("/");
    const slug = myArray[myArray.length - 1];

    const [tab, setTab] = useState(slug)
    const [size, setSize] = useState(350)
    const [isFullSize, setIsFullSize] = useState(true)
    const handleChangeSizeSideBar = () => {
        setSize(size === 350 ? 100 : 350)
        setIsFullSize(!isFullSize)
    }
    document.title = 'Quản trị'

    useEffect(() => {
        const chatbox = document.getElementById("fb-root");
        if (chatbox)
            chatbox.style.display = "none"

    }, [])
    return (
        <AdminWrapper>
            <AdminSideBar
                tab={tab}
                setTab={setTab}
                size={size}
                isFullSize={isFullSize}
                handleChangeSizeSideBar={handleChangeSizeSideBar}
            />
            <div className="admin_content" style={{ width: `calc(100% - ${size}px)` }}>
                <AdminHeader />
                <div className='admin_content_body'>
                    {
                        tab === 'dashboard' &&
                        <AdminDashBoard />
                    }
                    {
                        tab === 'staff' &&
                        <Staff />
                    }
                    {
                        tab === 'customer' &&
                        <Customer />
                    }
                    {
                        tab === 'tour-type' &&
                        <TourType />
                    }
                    {
                        tab === "news-category" &&
                        <NewsCategories />
                    }
                    {
                        tab === "news" &&
                        <News />
                    }
                    {
                        tab === "tour" &&
                        <Tour />
                    }
                    {
                        tab === "order" &&
                        <TourOrder />
                    }
                    {
                        tab === "bill" &&
                        <Bill />
                    }
                </div>
            </div>
        </AdminWrapper>
    )
}

export default Admin